<div class="method-type-editor">
  <ts-loading-overlay *ngIf="loading$ | async" [message]="'info.loading_data'"></ts-loading-overlay>
  <ts-loading-overlay *ngIf="saving$ | async" [message]="'alert.saving'"></ts-loading-overlay>

  <header class="method-type-editor__header">
    <h1>{{ 'title.method_editor' | translate }}</h1>
  </header>

  <div *ngIf="error$ | async as errorKey" class="method-type-editor__error" data-cy="method-type-load-error">
    <i class="ri-error-warning-line" aria-hidden="true"></i>
    <span>{{ errorKey | translate }}</span>
  </div>

  <div class="method-type-editor__field">
    <label class="method-type-editor__field-label" for="method-type-editor-name">
      {{ 'method_type_editor.label.name' | translate | uppercase }}
    </label>
    <input
      id="method-type-editor-name"
      class="ts-input"
      type="text"
      data-cy="method-type-name"
      [formControl]="nameControl"
      [class.has-error]="!!(nameError$ | async)"
    />
    <div class="method-type-editor__error" *ngIf="nameError$ | async as nameErrorKey" data-cy="method-type-name-error">
      <i class="ri-error-warning-line" aria-hidden="true"></i>
      <span>{{ nameErrorKey | translate }}</span>
    </div>
  </div>

  <hr class="method-type-editor__separator" />

  <ts-method-type-acquisition-form
    [assetTypeOptions]="(assetTypeOptions$ | async) ?? []"
    [assetTypesLoaded]="(assetTypesLoaded$ | async) ?? false"
    [selectedAssetType]="selectedAssetTypeItem$ | async"
    [assetTypeSearchTerm]="(assetTypeSearchTerm$ | async) ?? ''"
    [assetTypeErrorKey]="assetTypeError$ | async"
    [sampleNames]="(sampleNames$ | async) ?? []"
    [currentLanguage]="(currentLanguage$ | async) ?? 'en'"
    [manualConfigMode]="(manualConfigMode$ | async) ?? false"
    [methodTypeConfig]="methodTypeConfig$ | async"
    [configErrorKey]="configError$ | async"
    [canExitManualConfig]="(canExitManualConfig$ | async) ?? false"
    (assetTypeSelected)="onAssetTypeSelected($event)"
    (assetTypeSearchChanged)="onAssetTypeSearchChanged($event)"
    (assetTypeLastItemReached)="onAssetTypeLastItemReached()"
    (sampleNameAdded)="onSampleNameAdded($event)"
    (sampleNameRemoved)="onSampleNameRemoved($event)"
    (sampleNameUpdated)="onSampleNameUpdated($event)"
    (manualConfigRequested)="onManualConfigRequested()"
    (manualConfigExitRequested)="onManualConfigExitRequested()"
    (configChanged)="onConfigChanged($event)"
  ></ts-method-type-acquisition-form>

  <hr class="method-type-editor__separator" />

  <section class="method-type-editor__section">
    <ts-resource-manager></ts-resource-manager>
  </section>

  <hr class="method-type-editor__separator" />

  <section class="method-type-editor__section">
    <ts-method-asset-fields-manager
      [assetFields]="(acquisitionFields$ | async) ?? []"
      (fieldAdded)="onFieldAdded($event)"
      (fieldDeleted)="onFieldDeleted($event)"
    ></ts-method-asset-fields-manager>
  </section>

  <hr class="method-type-editor__separator" />

  <section class="method-type-editor__section">
    <ts-method-pipeline-manager></ts-method-pipeline-manager>
  </section>

  <div class="method-type-editor__actions">
    <button
      type="button"
      class="btn btn-outline-primary method-type-editor__action"
      data-cy="method-type-cancel"
      (click)="onCancel()"
    >
      <i class="ri-close-fill"></i>
      {{ 'button.cancel' | translate }}
    </button>
    <!-- Never disabled on invalid or on a failed save (the retry must stay
         clickable): clicking save with missing fields paints the errors -->
    <button
      type="button"
      class="btn btn-primary method-type-editor__action"
      data-cy="method-type-save"
      [disabled]="(loading$ | async) || (saving$ | async)"
      (click)="onSave()"
    >
      <i class="ri-save-line"></i>
      {{ confirmLabelKey | translate }}
    </button>
  </div>
</div>
